import classNames from 'classnames';
import { Icon, Picture, FlexContainer, Txt } from 'components';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useDataActions } from 'state';
import styles from './NoticeView.module.scss';

/**
 * NoticeView
 *
 * @return {JSX.Element}
 */
const NoticeView = ({ className, notice }) => {
  const storageActions = useDataActions();

  const item = notice;

  useEffect(() => {
    if (item && !item.data.hasViewed) {
      storageActions.notices.markAsViewed(item);
    }
  }, [item, storageActions.notices]);

  return (
    <FlexContainer
      className={classNames(
        styles.NoticeView,
        className,
        NoticeView.displayName
      )}
      column
    >
      <FlexContainer gap alignCenter className={styles.Header}>
        <Icon name="message" highlight="black" />
        <Txt xx>{item.data.messageFromName}</Txt>
      </FlexContainer>
      <FlexContainer column gap className={styles.Body}>
        <FlexContainer>
          <Txt caption mm>
            {DateTime.fromJSDate(
              fromSwiftDate(item.data.dateUpdated)
            ).toLocaleString(DateTime.DATETIME_MED)}
          </Txt>
        </FlexContainer>
        <FlexContainer>
          <Txt>{item.data.noticeTitle}</Txt>
        </FlexContainer>
        <FlexContainer>
          {item.data.isImage ? (
            <Picture src={item.data.messageText} />
          ) : (
            <Txt regular>{item.data.messageText}</Txt>
          )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

NoticeView.displayName = 'NoticeView';

export default observer(NoticeView);
